var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.snackBar.display)?_c('div',{staticClass:"snackbar notification",class:_vm.snackBar.color},[_vm._v("\n    "+_vm._s(_vm.snackBar.text)+"\n    "),_c('button',{staticClass:"delete",on:{"click":_vm.hideSnackbar}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }